module.exports = __webpack_public_path__ + "img/pinterest.6eff5ff9.svg";